import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue";
import { ElTooltip } from "element-plus";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Tooltip',
    props: {
        message: {},
        triggerType: {},
        positionType: { default: "top" },
        enterable: { type: Boolean },
        hideAfter: { default: 10 },
        showAfter: { default: 200 },
        showArrow: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const iconClass = () => {
            switch (props.triggerType) {
                case "info":
                    return "fal fa-info-circle";
                case "question-mark":
                    return "fal fa-question-circle";
                default:
                    return "";
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElTooltip), {
                content: _ctx.message,
                placement: _ctx.positionType,
                "hide-after": _ctx.hideAfter,
                "show-after": _ctx.showAfter,
                enterable: _ctx.enterable,
                "show-arrow": _ctx.showArrow
            }, {
                default: _withCtx(() => {
                    var _a;
                    return [
                        (_ctx.triggerType === 'question-mark' ||
                            _ctx.triggerType === 'info' ||
                            !((_a = _ctx.$slots.default) === null || _a === void 0 ? void 0 : _a.call))
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                class: _normalizeClass(iconClass())
                            }, null, 2 /* CLASS */))
                            : _renderSlot(_ctx.$slots, "default", { key: 1 })
                    ];
                }),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["content", "placement", "hide-after", "show-after", "enterable", "show-arrow"]));
        };
    }
});
